import {
  FormFieldSchema,
  FormFieldType,
} from "@app/components/forms/types/schema";

export const PriceAgreementSchema: FormFieldSchema[] = [
  {
    id: "id",
    label: (
      <div>
        <span className="mr-1">쇼츠웍스</span>
        <span
          className="mr-1 underline cursor-pointer"
          onClick={(event) => {
            event.preventDefault();
            window.open("https://shortsworks.io/policy/service", "_blank");
          }}
        >
          이용약관
        </span>
        <span className="mr-1">및</span>
        <span
          className="underline cursor-pointer"
          onClick={(event) => {
            event.preventDefault();
            window.open("https://shortsworks.io/policy/privacy", "_blank");
          }}
        >
          개인정보 처리방침
        </span>
        <span>에 동의합니다.</span>
      </div>
    ),
    type: FormFieldType.Checkbox,
    behavior: {
      required: true,
    },
  },
  {
    id: "monthlyRecurringPayment",
    label: "매월 정기 결제에 동의합니다.",
    type: FormFieldType.Checkbox,
    behavior: {
      required: true,
    },
  },
];
